<app-ellipsis [content]="(value | currency) || '-'"></app-ellipsis>
